import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

export interface CategoryDialogData {
  name?: string;
  slug?: string;
  title?: string;
  actionLabel?: string;
  categoryUuid?: string;
  // Opcional: listado de porciones disponibles para asociar
  portionOptions?: { uuid: string; name: string }[];
  // Opcional: porciones actualmente asociadas a la categoría
  selectedPortionUuids?: string[];
}

@Component({
  selector: 'app-category-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule],
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Nueva categoría' }}</h2>
    <div mat-dialog-content class="space-y-3">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Nombre</mat-label>
        <input matInput [(ngModel)]="name" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Slug</mat-label>
        <input matInput [(ngModel)]="slug" />
      </mat-form-field>
      <mat-form-field *ngIf="data.portionOptions?.length" appearance="fill" class="w-100">
        <mat-label>Porciones asociadas</mat-label>
        <mat-select [(ngModel)]="portionUuids" multiple>
          <mat-option *ngFor="let p of data.portionOptions" [value]="p.uuid">
            {{ p.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button (click)="dialogRef.close(null)">Cancelar</button>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!name || !name.trim()">{{ data.actionLabel || 'Guardar' }}</button>
    </div>
  `,
})
export class CategoryDialogComponent {
  name = '';
  slug = '';
  portionUuids: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CategoryDialogData,
    public dialogRef: MatDialogRef<CategoryDialogComponent>
  ) {
    if (data) {
      this.name = data.name || '';
      this.slug = data.slug || '';
      this.portionUuids = [...(data.selectedPortionUuids || [])];
    }
  }

  save() {
    this.dialogRef.close({ name: this.name.trim(), slug: this.slug.trim(), enabled: true, portionUuids: this.portionUuids });
  }
}
